import OwnerController from "../owner_controller";
import moment from "moment";
import $ from "jquery";
import Pikaday from "pikaday";
import "../../../../assets/javascripts/admin/selectize.js";
import "../../../../assets/stylesheets/admin/selectize.bootstrap3.css";

const cfg = {
  default: moment().toDate(),
  format: "D MMM YYYY",
  start_date: {
    general: {
      min: moment()
        .subtract(5, 'months')
        .startOf("month")
        .toDate(),
      max: moment()
        .add(3, 'months')
        .endOf("month")
        .toDate()
    },
    by_hour: {
      min: moment()
        .subtract(60, 'days')
        .toDate(),
      max: moment()
        .add(60, 'days')
        .toDate()
    },
  },
  end_date: {
    min: moment().toDate(),
    max: moment()
      .add(1, 'month')
      .endOf("month")
      .toDate()
  }
};
export default class extends OwnerController {
  static targets = [
    "checkboxByHour",
    "startDate",
    "endDate",
    "startTime",
    "endTime",
    "showDatePicker",
    "showTimePicker",
    "buttonSubmit",
    "refreshMessage",
    "selectBranch",
    "restaurantId",
    "restaurantGroupId",
    "loading"
  ];
  static values = [];
  startDateInstance = null;
  endDateInstance = null;

  initialize() {
    this.initializePickers();
    this.reportByHourChanged();
    this.showLoading(false);
  }

  initializePickers() {
    const opt = {
      // bound: false,
      defaultDate: cfg.default,
      maxDate: cfg.start_date.by_hour.max,
      minDate: cfg.start_date.by_hour.min,
      format: cfg.format,
      setDefaultDate: true,
      container: this.startDateTarget.parentNode,
      field: this.startDateTarget,
      onSelect: () => {
        this.showRefreshMessage();
      }
    };
    this.endDateInstance = new Pikaday(
      Object.assign({}, opt, {
        field: this.endDateTarget,
        defaultDate: cfg.end_date.max,
        minDate: cfg.end_date.min,
        maxDate: cfg.end_date.max,
        container: this.endDateTarget.parentNode,
      })
    );
    this.startDateInstance = new Pikaday(
      Object.assign({}, opt, {
        onSelect: (s_date) => {
          this.showRefreshMessage();
          // recalculate & change end_date config
          const newMaxDate = moment(s_date).add(1, 'month');
          this.endDateInstance.setMinDate(s_date);
          this.endDateInstance.setMaxDate(newMaxDate.toDate());
          const isAfter = moment(s_date).isAfter(moment(this.endDateInstance.getMoment()));
          if (isAfter === true) this.endDateInstance.setDate(s_date);
          const isAfterMaxDate = moment(this.endDateInstance.getMoment()).isAfter(newMaxDate);
          if (isAfterMaxDate === true) this.endDateInstance.setDate(newMaxDate.toDate());
        }
      })
    );
    $(".selectize").selectize({
      allowEmptyOption: true,
      onChange: () => {
        this.showRefreshMessage();
      }
    });
  }

  showRefreshMessage(bool = true) {
    if (bool) {
      this.showLoading(false);
      this.setEmpty(this.branchCovers);
      this.setEmpty(this.dineIn);
      this.setEmpty(this.packageReport);
      this.setEmpty(this.dineInCovers);
      this.setEmpty(this.rating);
      this.setEmpty(this.serviceType);
      this.soldOut.showMessageBranch();
      return this.refreshMessageTarget.classList.remove('dn!');
    }
    this.refreshMessageTarget.classList.add('dn!');
  }

  async submitFilter() {
    if (this.buttonSubmitTarget.getAttributeNames().includes("disabled"))
      return;
    this.showRefreshMessage(false);
    this.showLoading();
    await Promise.all([
      this.branchCovers.fetch(),
      this.dineIn.fetch(),
      this.packageReport.fetch(),
      this.dineInCovers.fetch(),
      this.rating.fetch(),
      this.serviceType.fetch(),
      this.soldOut.fetch(),
    ])
    this.showLoading(false);
  }

  reportByHourChanged() {
    this.changeStartDateConfig();
    if (this.isByHour) return this.showTimePicker();
    this.showDatePicker();
    this.showRefreshMessage();
  }

  changeStartDateConfig() {
    const start_date_type = this.isByHour === true ? 'by_hour' : 'general';
    const minDate = cfg.start_date[start_date_type].min;
    const maxDate = cfg.start_date[start_date_type].max;
    const selectedDate = this.startDateInstance.getMoment();
    this.startDateInstance.setMinDate(minDate);
    this.startDateInstance.setMaxDate(maxDate);

    if (selectedDate.isBefore(moment(minDate))) this.startDateInstance.setDate(minDate);
    if (selectedDate.isAfter(moment(maxDate))) this.startDateInstance.setDate(maxDate);
  }

  showLoading(bool = true) {
    this.buttonSubmitTarget.toggleAttribute("disabled", bool);
    if (bool) return this.loadingTarget.classList.remove("dn!");
    this.loadingTarget.classList.add("dn!");
  }

  showTimePicker() {
    this.showTimePickerTargets.forEach(el => {
      el.classList.remove("dn!");
    });
    this.showDatePickerTargets.forEach(el => {
      el.classList.add("dn!");
    });
  }

  showDatePicker() {
    this.showTimePickerTargets.forEach(el => {
      el.classList.add("dn!");
    });
    this.showDatePickerTargets.forEach(el => {
      el.classList.remove("dn!");
    });
  }

  get dataFilter() {
    return {
      is_by_hour: this.isByHour,
      start_date: moment(this.startDateTarget.value).format('YYYY-MM-DD'),
      end_date: moment(this.endDateTarget.value).format('YYYY-MM-DD'),
      start_time: this.startTimeTarget.value,
      end_time: this.endTimeTarget.value,
      restaurant_id: this.hasSelectBranchTarget == true ? this.selectBranchTarget.value : this.restaurantIdTarget.value,
      restaurant_group_id: this.restaurantGroupIdTarget.value,
    }
  }

  get isByHour() {
    return this.checkboxByHourTarget.checked;
  }

  get restaurantGroupId() {
    return this.restaurantGroupIdTarget.value;
  }

  get restaurantId() {
    return this.hasSelectBranchTarget == true ? this.selectBranchTarget.value : this.restaurantIdTarget.value;
  }
}